module.exports = __webpack_public_path__ + "img/152.305dd23c.svg";